import gsap from 'gsap';
import LazyLoad from 'blazy';
import Flickity from 'flickity';
import Isotope from 'isotope-layout';
import VanillaTilt from 'vanilla-tilt';
import modularLoad from 'modularload';

const HTML = document.querySelector('html');

class App {
  constructor() { 

    /**
     * Lazyload
     */
    this.lazyload = new LazyLoad({ 
      // eslint-disable-next-line camelcase
      selector: '.js-lazy',
      offset: 600,
      breakpoints: [
        {
          width: 992, 
          src: 'data-src-small'
        }
      ],
      success : (el) => {
        const figure = el.closest('figure');
        if( figure ) figure.classList.add('img-is-loaded')
      },
    });

    /**
     * Custom cursor
     */
    const cursor = document.querySelector('.custom-cursor');
    if( cursor ) {
      const svgs = cursor.querySelectorAll('svg');
      document.addEventListener('mouseenter', e => {
        gsap.to(cursor, { duration: 0.2, autoAlpha : 1 })
      })
      document.addEventListener('mouseleave', e => {
        gsap.to(cursor, { duration: 0.2, autoAlpha : 0 })
      })
      window.addEventListener('mousemove', cursorMove)
      const links = document.querySelectorAll('a:not([href*="#"])');
      
      if( links ) {
        links.forEach( link => {
          link.addEventListener('mouseenter', e => {
            gsap.to(svgs, { duration: 0.3, ease : 'expo.out', scale : 1.5 })
            gsap.set(cursor, { 'mix-blend-mode' : 'exclusion' });
          })
          link.addEventListener('mouseleave', e => {
            gsap.to(svgs, { duration: 0.3, ease : 'expo.out', scale : 1 })
            gsap.set(cursor, { 'mix-blend-mode' : 'unset' });
          })
        })
      }

      function cursorMove(e) {
        gsap.to(cursor, { duration: 0.2, autoAlpha : 1 })
        svgs.forEach((cursor, i) => {
          gsap.set(cursor, { x : e.clientX, y : e.clientY, delay:  i * 0.02 })
        })
      }
    }

    // We listen to the resize event
    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
    window.dispatchEvent(new Event('resize'));

    this.init();

    this.load = new modularLoad({
      enterDelay: 300,
    })

    this.load.on('loading', (transition, oldContainer, newContainer) => {
      this.loader('loading')
    })
    this.load.on('loaded', (transition, oldContainer, newContainer) => {
      window.scrollTo(0, 0);

      const scripts = newContainer.getElementsByTagName('script');
      if( scripts && scripts.length > 0 ) {
        for( let i = 0; i < scripts.length; i++) {
          const s = document.createElement('script')
          s.setAttribute("src", scripts[i].getAttribute('src'));
          document.body.append(s);
        }
      }

      setTimeout(() => {
        if( typeof gtag != 'undefined' ) {
          gtag('js', new Date());
          gtag('config', 'G-2C1F0EQ2DD');
        }

        this.init();
        this.lazyload.revalidate();
        this.loader('loaded', false, () => {
          this.reveal();
        })
      }, 150)
    })

    this.loader('loaded', true, () => {
      this.reveal();
    })
  }

  init() {
    const bigHeart = document.querySelector('.big-heart');

    /**
     * Parallax
     */
     if( bigHeart && 
        (
          navigator.userAgent.indexOf("Chrome") > -1 ||
          navigator.userAgent.indexOf("MSIE") > -1 ||
          navigator.userAgent.indexOf("Edge") > -1 ||
          navigator.userAgent.indexOf("Firefox") > -1
        )
      ) {
      VanillaTilt.init(bigHeart.parentNode, {
        perspective : 1500,
      })
    }

    /**
     * Grid isotope
     */
    const isotopes = document.querySelectorAll('.isotope-grid');
    if( isotopes ) {
      isotopes.forEach(isotope => {
        const iso = new Isotope(isotope, {
          itemSelector : '.item',
        })
      })
    }

    /**
     * Textarea
     */
    // expand height textarea
    function autoExpand(field) {
      // Reset field height
      field.style.height = 'inherit';

      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);

      // Calculate the height
      const height =
        parseInt(computed.getPropertyValue('border-top-width'), 10) +
        // parseInt(computed.getPropertyValue('padding-top'), 10) +
        field.scrollHeight +
        // parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        parseInt(computed.getPropertyValue('border-bottom-width'), 10);

      field.style.height = `${height}px`;
    }

    document.addEventListener('input', (event) => {
      if (event.target.tagName.toLowerCase() !== 'textarea') return;
      autoExpand(event.target);
    });

    this.burger()
    this.artist();
    this.sticky();
    this.frise();
    this.scroll();
    this.carousel();
  }

  burger() {
    /**
     * Show navigation
     */
    const triggerMenu = document.querySelectorAll('.toggle-menu:not(.ready)')
    if( triggerMenu ) {
      triggerMenu.forEach(el => {
        el.classList.add('ready') 
        el.addEventListener('click', clickBurger)
      }) 
    } 
    
    function clickBurger(e) {
      e.preventDefault();
      e.stopPropagation();
      HTML.classList.toggle('open-menu')
      return false;
    } 
  }

  reveal() {

    // In viewport
	  const offsetT = window.innerHeight * .15;
    const reveals = document.querySelectorAll('.js-reveal:not(.is-visible)');
    if( reveals ) {
      window.addEventListener('scroll', e => {
        reveals.forEach((el, i) => {
          if( el.classList.contains('is-visible')) return false;

          if(inViewport(el)) {
            el.classList.add('is-visible');
          }
        })
      })
      window.dispatchEvent(new Event('scroll'));

      function inViewport(element) {
        const { top, right, bottom, left, width, height } = element.getBoundingClientRect();
        return top <= window.innerHeight - offsetT;
      }
    }
  }

  loader(step, start = false, callback = null) {
    const loader = document.querySelector('.loader');
    const cursor = document.querySelector('.custom-cursor');

    if( loader ) {
      const svgs = cursor.querySelectorAll('svg');
      const loaderSvgs = loader.querySelectorAll('.svg');
      const loaderLogo = loader.querySelector('svg');
  
      if( loaderSvgs ) {
        const bound = svgs[0].getBoundingClientRect()
        let bgPX =  (bound.x + bound.width / 2) - window.innerWidth / 2
        let bgPY = ( bound.y + bound.height / 2) - window.innerHeight / 2

        if( start || window.innerWidth <= 1024) {
          bgPX = bgPY = 0
        }
        gsap.set( loaderSvgs, { backgroundPosition : `calc(${bgPX}px + 50%) calc(${bgPY}px + 50%)` })
      }

      if( step == 'loading' ) {
        gsap.set(loader, { autoAlpha : 1 })
        const tl = gsap.timeline({ 
          paused : true,
          onComplete : () => {
            HTML.classList.remove('open-menu')
            gsap.set(document.querySelectorAll('html, body'), { scrollTop : 0 })

            if( callback != null ) callback.call();
          } 
        })
        tl
          .to( loaderSvgs, { 
            stagger: {
              amount : 0.06, 
              from : 'end'
            },
            duration : 0.5,
            ease : 'circ.in',
            backgroundSize : `400vmax`
          } )
          .fromTo(loaderLogo, {
            autoAlpha : 0,
            y : '0%'
          }, {
            autoAlpha : 1,
            y : '-50%',
            duration : 0.5
          }, '-=0.2')
          tl.play();
      } else {
        gsap.to( loaderLogo, { 
          autoAlpha : 0,
          y : '-100%',
          duration : 0.3,
        } )
        gsap.to( loaderSvgs, { 
          stagger: {
            amount : 0.06, 
          },
          duration : 0.5,
          ease : 'circ.out',
          backgroundSize : `0`,
          onComplete : () => {
            gsap.set(loader, { autoAlpha : 0 })
            if( callback != null ) callback.call();
          }
        } )
      }
      
    }
  }

  carousel() {

    /**
     * Carousel
     */
    const carousels = document.querySelectorAll('.carousel');
    if( carousels ) {
      carousels.forEach(el => {
        var flkty = new Flickity( el, {
          cellAlign : 'left',
          contain : true,
          pageDots: false,
          prevNextButtons : false,
          lazyLoad : 5
        });
      })
    }
  }

  artist() {
    /**
     * List artist
     */
     const listartists = document.querySelector('.artists');
     if( listartists ) {
       let current = '';
       const iso = new Isotope(listartists, {
         itemSelector : '[class*="grid-col-"]',
         layoutMode: 'fitRows'
       })
 
       const filters = document.querySelectorAll('[data-filter]');
       if( filters ) {
         filters.forEach(f => {
           f.addEventListener('click', e => {
             e.preventDefault();
             iso.arrange({ filter: f.dataset.filter });
             current = f.dataset.filter;
             posCursor();
             setTimeout(() => {
               window.dispatchEvent(new Event('scroll'))
             }, 400)
           })
         })
 
         const parent = filters[0].closest('.flex');
 
         const cursor = document.querySelector('.cursor');
         function posCursor() {
           if( cursor ) {
             const currentFilter = document.querySelector(`[data-filter="${current}"]`);
             if( currentFilter ) {
               const pos = currentFilter.getBoundingClientRect();
               const postParent = parent.getBoundingClientRect();
               gsap.set(cursor, { x : pos.x - postParent.x, height : pos.height, width : pos.width })
             }
           }
         }
         posCursor();
         setTimeout(() => {
          gsap.set(cursor, { autoAlpha : 1 })
         }, 800)
       }
     }


    const artists = document.querySelectorAll('.artist-trigger');
    if( artists && artists.length > 0) {
      let timer = 0;
      const lightbox = document.querySelector('.artist-lightbox');
      const heart = document.querySelector('.artist-heart');
      const pattern = heart.querySelector('pattern image')

      const closeLightbox = lightbox.querySelector('.trigger-close');
      if( closeLightbox ) {
        closeLightbox.addEventListener('click', e => {
          e.preventDefault(); 
          HTML.classList.remove('show-lightbox')
          const activeEls = lightbox.querySelectorAll('.show')
          if( activeEls ) activeEls.forEach(el => el.classList.remove('show'));
        })
      }


      artists.forEach(artist => {

        // MOUSEENTER
        artist.addEventListener('mouseenter', e => {
          const url = artist.dataset.img;
          if( url != '' ) {
            const img = document.createElement('img');
            img.src = url;

            img.onload = function() {
              clearTimeout(timer);
              heart.classList.add('scale-105')
              heart.classList.remove('opacity-0')
              pattern.setAttribute('xlink:href', url);

              gsap.fromTo(pattern, { scale : 1}, { duration : 10, scale : 1.2, transformOrigin: 'center center'})
            }
          }
        })

        // MOUSELEAVE
        artist.addEventListener('mouseleave', e => {
          heart.classList.remove('scale-105')
          heart.classList.add('opacity-0')
          timer = setTimeout(() => {
            pattern.setAttribute('xlink:href', '');
          }, 300)
        })

        // CLICK
        artist.addEventListener('click', e => {
          e.preventDefault();
          const id = artist.dataset.artist;
          const target = lightbox.querySelector(`[data-artist="${id}"]`);

          if( target ) {
            HTML.classList.add('show-lightbox')
            target.classList.add('show');
          }

        })
      })

      window.addEventListener('scroll', () => {
        heart.classList.remove('scale-105')
        heart.classList.add('opacity-0')
      })
    }
  }

  scroll() {

    /**
     * Show menu
     */
     const header = document.querySelector('.main-header');
     const footer = document.querySelector('.main-footer');
     const main = document.querySelector('.main');
     const haveHero = main.children.length > 0 && main.children[0].classList.contains('cover') ;
     const bigHeart = document.querySelector('.big-heart');
     header.classList.remove('show');
 
     window.removeEventListener('scroll', onscroll)
     window.addEventListener('scroll', onscroll)

     function onscroll(e) {
      const y = window.scrollY;

      if( haveHero ) {
        const pos = main.children[0].getBoundingClientRect();
        if( pos.bottom <= 0 ) {
          header.classList.add('show');
        } else {
          header.classList.remove('show');
        }
        
        if( bigHeart ) {
          const posFooter = footer.getBoundingClientRect();
          const posHeart = bigHeart.getBoundingClientRect();

          if( window.innerHeight - posFooter.top >= (window.innerHeight - posHeart.height) / 2 ) {
            gsap.set( bigHeart, {
              bottom : window.innerHeight - posFooter.top,
            })
            bigHeart.classList.remove('-translate-y-1/2', 'top-1/2')
          } else {
            gsap.set( bigHeart, { bottom : 'auto' })
            bigHeart.classList.add('-translate-y-1/2', 'top-1/2')
          }
        }

      } else {
        header.classList.add('show');
      }
     }
     window.dispatchEvent(new Event('scroll'));
  }

  frise() {
    const frises = document.querySelectorAll('.frise');

    if( frises ) {
      frises.forEach(frise => {
        const container = frise.querySelector('.frise--container');
        const content = frise.querySelector('.frise--content');
        const imgs = frise.querySelectorAll('.frise--imgs figure');

        window.addEventListener('resize', e => {
          const pos = content.getBoundingClientRect();
          if( window.innerWidth > 768 ) {
            gsap.set(frise, {
              height : (pos.width - window.innerWidth) + window.innerHeight
            })
          }
        })
        window.dispatchEvent(new Event('resize'))

        window.addEventListener('scroll', e => {
          if( window.innerWidth > 768 ) {
            const pos = frise.getBoundingClientRect();
            if( pos.bottom - window.innerHeight <= 0 ) {
              gsap.set(container, {
                position : 'absolute',
                top : 'auto',
                bottom : 0,
                left: 0
              })
            } 
            else if( pos.top <= 0 ) {
              gsap.set(container, {
                position : 'fixed',
                top : 0,
                bottom: 'auto',
                left: 0
              })

              // Move
              gsap.set(content, {
                x : pos.top
              })
              imgs.forEach(img => {
                gsap.set(img, {
                  x : pos.top * (img.dataset.velocity ? parseFloat(img.dataset.velocity) : 0.3)
                })
              })
            } 
            else {
              gsap.set(container, {
                position : 'relative',
                top : 0,
                left: 0
              })
            }
          }
        })
        window.dispatchEvent(new Event('scroll'))
      })
    }
  }
  
  /** 
   * Sticky element when in top viewport
   */
  sticky() {
    const stickys = document.querySelectorAll('[data-sticky]');
    
    if( stickys ) {
      if( window.innerWidth <= 992 ) return false;

      stickys.forEach(el => {
        const parent = el.parentElement;

        // Keep height
        window.addEventListener('resize', e => {
          const pos = el.getBoundingClientRect();
          parent.style.height = `${pos.height}px`;
        })
        window.dispatchEvent(new Event('resize'));

        window.addEventListener('scroll', (e) => {
          const pos = el.getBoundingClientRect();
          const pPos = parent.getBoundingClientRect();
          const offset = el.dataset.stickyOffset ? document.querySelector(el.dataset.stickyOffset).offsetHeight : 0;
          const container = el.dataset.stickyContainer ? document.querySelector(el.dataset.stickyContainer) : false;
          const containerPos = container ? container.getBoundingClientRect() : 0;

          // Now sticky
          if( pPos.top - offset <= 0 ) {
            el.style.width = `${pPos.width}px`
            if( container && containerPos.bottom - pos.height - offset <= 0 ) {
              el.style.position = 'absolute'
              el.style.top = `auto`
              el.style.bottom = `0px`
              el.style.left = `0px`
            } else {
              el.style.position = 'fixed'
              el.style.top = `${offset}px`
              el.style.bottom = `auto`
              el.style.left = `${pPos.x}px`
            }
          } else {
            el.style.position = 'absolute'
            el.style.top = `0px`
            el.style.bottom = `auto`
            el.style.left = `0px`
            el.style.width = `100%`
          }
        })

        window.dispatchEvent(new Event('scroll'));
      })
    }
  }
}

 
window.addEventListener('load', () => {
  new App();
})